import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["data-hidden-assemblies"];
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  class: "badge"
};
const _hoisted_5 = ["title"];
const _hoisted_6 = {
  class: "box-inner"
};
const _hoisted_7 = {
  class: "flex"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1,
  class: "image"
};
const _hoisted_10 = {
  key: 2,
  class: "content"
};
const _hoisted_11 = {
  class: "options-label"
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "badge"
};
const _hoisted_14 = ["title"];
const _hoisted_15 = {
  class: "badge bg-green"
};
const _hoisted_16 = {
  key: 1,
  class: "product-options"
};
const _hoisted_17 = {
  class: "flex"
};
const _hoisted_18 = {
  class: "ic"
};
const _hoisted_19 = {
  class: "flex-body"
};
const _hoisted_20 = {
  class: "error"
};
const _hoisted_21 = {
  class: "text-left"
};
const _hoisted_22 = {
  class: "footer text-center"
};
import { ref, computed, getCurrentInstance } from "vue";
import { useConfiguratorStore } from "@/stores/configuratorData";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import { isProductSelected } from "../utils/responseUtil";
import { openFullLoading } from "@/utils/tools";
import { resetAssembly } from "@/api/obj.api";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/_defineComponent({
  __name: 'productOptions',
  emits: ["updateActiveTab"],
  setup(__props, {
    emit: __emit
  }) {
    const {
      t
    } = useI18n();
    const emit = __emit;
    const configuratorStore = useConfiguratorStore();
    const attribute = useAdditionalAttrStore();
    const visibleAlertMessage = ref(false);
    const visibleAlertMessageFor = ref("");
    function getTabKey(currentCoding) {
      /*
       * Currently represents the entire object to force a refresh of the label template when any property changes.
       * Changing this behavior may lead to the label DOM not automatically changing.
       */
      return JSON.stringify(currentCoding);
    }
    function isProductOptional(product) {
      const certificate = configuratorStore.getSelectedCertificateGroup.items.find(item => item.codeTypeId === product.CodeTypeId);
      if (certificate) {
        return certificate.optional;
      } else {
        return product.Optional === "Yes";
      }
    }
    const thumbnailUrl = computed(() => {
      const selectedProduct = configuratorStore.getSelectedProduct;
      let url = null;
      const codeTypeId = selectedProduct?.CodeTypeId;
      if (codeTypeId) {
        const imgData = configuratorStore.getImageByCodeTypeId(codeTypeId);
        if (imgData) {
          url = imgData?.rs_w90_h90_image;
        }
      }
      if (typeof url !== "string") {
        url = attribute.getDataConfig.thumbnailsPlaceholderUrl || require("@/assets/images/option-placeholder.png");
      }
      return url;
    });
    const tabs = computed(() => {
      const storedCurrentCoding = configuratorStore.getCurrentState?.CurrentCoding ?? [];
      const selectedItem = storedCurrentCoding.find(isProductSelected);
      let parent = selectedItem?.Parent;
      if (!parent) {
        parent = selectedItem?.CodeTypeId;
      }
      const selectedCertificates = configuratorStore.getSelectedCertificateGroup.items.map(item => item.codeTypeId);
      return storedCurrentCoding.filter(currentCoding => configuratorStore.deletedCertificates.includes(currentCoding.CodeTypeId) == false && (currentCoding.CodeTypeId === parent || currentCoding.Parent === parent && currentCoding.Optional !== "Yes" || selectedCertificates.includes(currentCoding.CodeTypeId)));
    });
    const {
      eventBus
    } = getCurrentInstance()?.appContext.config.globalProperties ?? {
      eventBus: undefined
    };
    const handleOptionsChange = async tabName => {
      const loading = openFullLoading(false, t("text.loading"));
      try {
        await configuratorStore.ChangeAssembly(tabName.toString());
      } finally {
        loading.close();
      }
      eventBus.emit("switchToProductImage", true);
      emit("updateActiveTab");
    };
    const selectedTab = computed({
      get() {
        return configuratorStore.getCurrentState?.CurrentCoding.find(isProductSelected)?.CodeTypeId ?? "";
      },
      set(tabName) {
        handleOptionsChange(tabName);
      }
    });
    const getPanelCompleted = cc => {
      let finalClass = "txt-info";
      let codeIsComplted = true;
      cc.forEach(v => {
        if (!isProductSelected(v)) {
          if (v.Complete === "No") {
            codeIsComplted = false;
          }
        }
      });
      if (codeIsComplted) {
        finalClass = "txt-success";
      }
      return finalClass;
    };
    const displayCriterias = computed(() => {
      return configuratorStore.getCriteriasByType("I");
    });
    const isDialogOpen = ref(false);
    const dialogKey = ref(0);
    const replace = itemId => {
      dialogKey.value += 1;
      const OriginatorsItem = itemId.Originators ? itemId.Originators[0].CodeTypeId : "";
      useConfiguratorStore().setlastSelectedOption(itemId.Originators[0]);
      useConfiguratorStore().setlastSelectedcodeType(OriginatorsItem);
      isDialogOpen.value = true;
    };
    const iconClickHandle = event => {
      event.stopPropagation();
      event.preventDefault();
    };
    const ChangeAssembly = () => {
      const loading = openFullLoading(false, t("text.loading"));
      resetAssembly(visibleAlertMessageFor.value).then(() => {
        configuratorStore.deleteCertificate(String(visibleAlertMessageFor.value));
        // configuratorStore.ChangeAssembly(visibleAlertMessageFor.value).then(() => {
        visibleAlertMessage.value = false;
        emit("updateActiveTab");
        // });
        loading.close();
      });
    };
    return (_ctx, _cache) => {
      const _component_optional_certificate_dialog = _resolveComponent("optional-certificate-dialog");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_skeleton = _resolveComponent("el-skeleton");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(configuratorStore).getCurrentState ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "product-options",
        "data-hidden-assemblies": _unref(attribute).getDataConfig.hideAssemblies
      }, [(_openBlock(), _createBlock(_component_optional_certificate_dialog, {
        modelValue: isDialogOpen.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isDialogOpen.value = $event),
        key: dialogKey.value,
        "show-close": true
      }, null, 8, ["modelValue"])), _createVNode(_component_el_tabs, {
        onTabChange: handleOptionsChange,
        "model-value": selectedTab.value,
        class: "tabs-product-options"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (code, key) => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: getTabKey(code),
            name: code.CodeTypeId
          }, {
            label: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass({
                flex: code.CodeTypeId !== '',
                success: code.Complete === 'Yes',
                warning: code.Complete !== 'Yes',
                'is-first': key === 0
              })
            }, [_createElementVNode("i", {
              class: _normalizeClass(_unref(configuratorStore).getCurrentState?.CodeComplete ? 'iconfont icon-status-success' : 'iconfont icon-status-attention')
            }, null, 2), _createElementVNode("div", _hoisted_2, [key == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(code.CodeTypeName), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("i", {
              class: "iconfont icon-certificate"
            }, null, -1)), _createTextVNode(" " + _toDisplayString(code.CodeTypeName), 1)])), _createElementVNode("div", {
              class: "desc",
              title: code.Description
            }, _toDisplayString(code.Description), 9, _hoisted_5)]), key != 0 ? (_openBlock(), _createBlock(_component_el_dropdown, {
              key: 0,
              class: "options-dropdown",
              "popper-class": "configurator-dropdown",
              trigger: "click"
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                  onClick: $event => handleOptionsChange(code.CodeTypeId)
                }, {
                  default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("i", {
                    class: "iconfont icon-edit-fill"
                  }, null, -1)), _createElementVNode("span", null, _toDisplayString(code.Category == "Certificates" ? _ctx.$t("button.editCertificate") : code.CodeTypeName == "LABEL" ? _ctx.$t("button.editLabel") : _ctx.$t("button.editProduct")), 1)]),
                  _: 2
                }, 1032, ["onClick"]), _createVNode(_component_el_dropdown_item, {
                  disabled: !isProductOptional(code),
                  class: "red",
                  onClick: $event => replace(code)
                }, {
                  default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("i", {
                    class: "iconfont icon-reset"
                  }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("button.replaceProduct")), 1)]),
                  _: 1
                }, 8, ["disabled", "onClick"])]),
                _: 2
              }, 1024)]),
              default: _withCtx(() => [_createElementVNode("span", {
                class: "el-dropdown-link",
                onClick: iconClickHandle
              }, [...(_cache[4] || (_cache[4] = [_createElementVNode("i", {
                class: "iconfont icon-more-options"
              }, null, -1)]))])]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)], 2)]),
            default: _withCtx(() => [_createElementVNode("div", {
              class: _normalizeClass(_unref(attribute).getDataConfig.hideAssemblies ? 'is-first box' : 'box')
            }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_unref(attribute).dataConfig.shellModels && _unref(attribute).dataConfig.shellModels.length > 0 && _unref(configuratorStore)?.getCurrentState?.CurrentCoding[0].CodeTypeId == code.CodeTypeId && _unref(attribute).dataConfig.shellModels.map(model => model.toLowerCase()).includes(_unref(configuratorStore)?.getCurrentState?.CurrentCoding[0].CodeTypeId.toLowerCase()) ? (_openBlock(), _createElementBlock("div", _hoisted_8)) : thumbnailUrl.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_image, {
              style: _normalizeStyle(_unref(configuratorStore).getImageStyleState),
              src: thumbnailUrl.value,
              fit: "contain"
            }, null, 8, ["style", "src"])])) : _createCommentVNode("", true), _unref(configuratorStore).getCurrentState ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("h6", null, _toDisplayString(_ctx.$t("header.type")) + " " + _toDisplayString(code.CodeTypeName), 1), _createVNode(_component_el_descriptions, {
              title: code.Description,
              column: 1
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayCriterias.value, (item, ck) => {
                return _openBlock(), _createBlock(_component_el_descriptions_item, {
                  key: ck,
                  label: item.Description,
                  "label-class-name": "w50"
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.ConfiguratorOptionDescription), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 1
            }, 8, ["title"])])) : _createCommentVNode("", true)])])], 2)]),
            _: 2
          }, 1032, ["name"]);
        }), 128))]),
        _: 1
      }, 8, ["model-value"]), tabs.value.length > 1 ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        trigger: "click",
        class: "opt-abs-dropdown",
        "destroy-on-close": "",
        "popper-class": "configurator-options-menu"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (code, key) => {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              key: key,
              class: _normalizeClass({
                hide: _unref(isProductSelected)(code)
              }),
              onClick: $event => handleOptionsChange(code.CodeTypeId)
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass({
                  flex: code.CodeTypeId !== '',
                  success: code.Complete === 'Yes',
                  warning: code.Complete !== 'Yes',
                  'is-first': key === 0
                })
              }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("i", {
                class: _normalizeClass(code.Complete == 'Yes' ? 'iconfont icon-status-success' : 'iconfont icon-status-attention')
              }, null, 2), _createElementVNode("span", _hoisted_13, [_cache[8] || (_cache[8] = _createElementVNode("i", {
                class: "iconfont icon-certificate"
              }, null, -1)), _createTextVNode(" " + _toDisplayString(code.CodeTypeName), 1)])]), _createElementVNode("div", {
                class: "desc",
                title: code.Description
              }, _toDisplayString(code.Description), 9, _hoisted_14), key != 0 ? (_openBlock(), _createBlock(_component_el_dropdown, {
                key: 0,
                class: "options-dropdown",
                "popper-class": "configurator-dropdown",
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
                    default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("i", {
                      class: "iconfont icon-edit-fill"
                    }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("button.edit")), 1), _createElementVNode("span", _hoisted_15, [_cache[10] || (_cache[10] = _createElementVNode("i", {
                      class: "iconfont icon-certificate"
                    }, null, -1)), _createTextVNode(" " + _toDisplayString(code.CodeTypeId), 1)])]),
                    _: 2
                  }, 1024), _createVNode(_component_el_dropdown_item, {
                    divided: ""
                  }, {
                    default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("i", {
                      class: "iconfont icon-edit-fill"
                    }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("button.editProduct")), 1)]),
                    _: 1
                  }), _createVNode(_component_el_dropdown_item, {
                    class: "red",
                    onClick: $event => replace(code)
                  }, {
                    default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("i", {
                      class: "iconfont icon-reset"
                    }, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$t("button.replaceProduct")), 1)]),
                    _: 1
                  }, 8, ["onClick"])]),
                  _: 2
                }, 1024)]),
                default: _withCtx(() => [_createElementVNode("span", {
                  class: "el-dropdown-link",
                  onClick: iconClickHandle
                }, [...(_cache[9] || (_cache[9] = [_createElementVNode("i", {
                  class: "iconfont icon-more-options"
                }, null, -1)]))])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)], 2)]),
              _: 2
            }, 1032, ["class", "onClick"]);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", {
          class: _normalizeClass(getPanelCompleted(tabs.value))
        }, "+" + _toDisplayString(tabs.value.length - 1), 3), _cache[7] || (_cache[7] = _createElementVNode("i", {
          class: "iconfont icon-arrow-up"
        }, null, -1))])]),
        _: 1
      })) : _createCommentVNode("", true)], 8, _hoisted_1)) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_el_skeleton, {
        row: "2"
      })])), _createVNode(_component_el_dialog, {
        modelValue: visibleAlertMessage.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => visibleAlertMessage.value = $event),
        "modal-class": "configurator-popup configurator-popup-error",
        "show-close": true,
        width: "808px",
        "append-to-body": true,
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_svg_icon, {
          "icon-class": "alert-white"
        })]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.status")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.cancelConfirm")) + " " + _toDisplayString(visibleAlertMessageFor.value), 1)]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => visibleAlertMessage.value = !visibleAlertMessage.value),
          type: "info"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: ChangeAssembly,
          type: "danger",
          class: "add-new"
        }, {
          default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("i", {
            class: "iconfont icon-plus-circle-fill"
          }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.yes")), 1)]),
          _: 1
        })])])])])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});